// en, de, fr, pt
export default {
	en: {
		Dashboard: 'Dashboard',
		Packages: 'Packages',
		AddPackages: 'Add Package',
		AllPackages: 'All Packages',
		Modules: 'Modules',
		AddModule: 'Add Module',
		AllModules: 'All Modules',
		Teachers: 'Teachers',
		AllTeachers: 'All Teachers',
		AddTeacher: 'Add Teacher',
		Students: 'Students',
		AllStudents: 'All Students',
		AddStudent: 'Add Student',
		Settings: 'Settings',
		Calendar: 'Calendar',
		Chat: 'Chat',
	},
	fr: {
		
	},
	pt: {
		
	}
}
